import React from 'react';
import { Box, Divider, Button, Typography } from '@mui/material';
import { CloseIcon } from 'icons/materialIcons';
import { ArrowDropDownRounded as ArrowDropDownRoundedIcon } from '@mui/icons-material';

const TeamLeadCaptureOverlayPreview = ({
    onClose,
    width = '280px',
    height = 'auto',
    connectButtonColor = '#2f82ed',
    inputFields = [
        { label: 'Full Name', required: false, type: 'text' },
        { label: 'Email', required: true, type: 'text' },
        { label: 'Phone Number', required: false, type: 'text' },
        { label: 'Job Title', required: false, type: 'text' },
        { label: 'Company', required: false, type: 'text' },
        { label: 'Note', required: false, type: 'text' }
    ]
}) => {

    return (
        <Box
            sx={{
                width: width,
                height: height,
                backgroundColor: '#fff',
                padding: '16px',
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                position: 'relative',
                overflow: 'hidden',
                maxWidth: '280px',
                maxHeight: '400px',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '4px',
                    position: 'relative',
                }}
            >
                <Divider sx={{ flexGrow: 1 }} />
                <CloseIcon
                    onClick={onClose}
                    sx={{
                        color: '#c4c4c4',
                        cursor: 'pointer',
                        ml: 1,
                        fontSize: '18px',
                    }}
                />
            </div>

            {/* Input Field Previews */}
            {inputFields.map((field, index) => {
                const fieldLabel = typeof field === 'string' ? field : field.label;
                const isDropdown = typeof field === 'object' && field.type === 'dropdown';
                return (
                    <Box
                        key={index}
                        sx={{
                            height: '28px',
                            mb: 0.5,
                            border: '1px solid #c5c5c5',
                            borderRadius: '8px',
                            position: 'relative',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography
                            sx={{
                                color: '#666666',
                                fontSize: '0.75rem',
                            }}
                        >
                            {fieldLabel}
                        </Typography>
                        {isDropdown && (
                            <ArrowDropDownRoundedIcon
                                sx={{
                                    fontSize: '1.25rem',
                                    color: '#828282',
                                }}
                            />
                        )}
                    </Box>
                );
            })}

            {/* Connect Button */}
            <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                    borderRadius: '16px',
                    padding: '6px',
                    textTransform: 'none',
                    backgroundColor: connectButtonColor,
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    marginTop: '8px',
                }}
            >
                Connect
            </Button>

            {/* Disclaimer Text */}
            <Typography
                variant="body2"
                sx={{
                    textAlign: 'center',
                    marginTop: 1.5,
                    fontWeight: 'bold',
                    fontSize: '0.6rem',
                    color: '#666666',
                }}
            >
                Touch does not sell or share your data
            </Typography>
        </Box>
    );
};

export default TeamLeadCaptureOverlayPreview;